import * as React from 'react';

import { Button } from '@ao-internal/components-react';
import * as digitalData from '@ao-internal/digital-data';

import { IconClassMap, IconTypes, TaggingEventNames } from '../../globals';
import { ChatMessageTypes, ChatMessageTypesClassMap } from '../../store';

export enum BehaviourTypes {
	SameTab,
	PopupWindow,
	NewTab,
}

export const BehaviourTypesStringMap: { [key: number]: string } = {
	[BehaviourTypes.SameTab]: 'same tab',
	[BehaviourTypes.PopupWindow]: 'popup window',
	[BehaviourTypes.NewTab]: 'newtab',
};

export interface LinkButtonMessageContent {
	text: string;
	url: string;
	linkType?: unknown; // Defunct
	iconType?: IconTypes;
	behaviour?: BehaviourTypes;
}

interface LinkButtonMessageProps {
	button: LinkButtonMessageContent;
}

export const dataTestId = `${
	ChatMessageTypesClassMap[ChatMessageTypes.LinkButton]
}-message`;

export const LinkButtonMessage: React.FC<LinkButtonMessageProps> = ({
	button,
}) => {
	const { iconType, url, text, behaviour } = button;
	const behaviourTag = behaviour
		? BehaviourTypesStringMap[behaviour]
		: BehaviourTypesStringMap[BehaviourTypes.SameTab];
	const iconClass = iconType !== undefined ? IconClassMap[iconType] : false;

	const handleClick = (evt: React.MouseEvent) => {
		if (behaviour === BehaviourTypes.PopupWindow) {
			evt.preventDefault();
			window.open(
				url,
				'popUpWindow',
				'height=590,width=800,resizable=no,scrollbars=no,toolbar=no,menubar=no,location=no,directories=no, status=yes'
			);
		}

		digitalData.sendBeacon(TaggingEventNames.interaction, {
			type: 'click',
			element: 'link-button',
			text: text,
			url: url,
		});
	};

	return (
		<div
			data-testid={dataTestId}
			className="mx-2 mb-2"
			data-tag-area="link message button"
		>
			{iconClass ? (
				<Button
					target={behaviour === BehaviourTypes.NewTab ? '_blank' : undefined}
					rel={
						behaviour === BehaviourTypes.NewTab
							? 'noopener noreferrer'
							: undefined
					}
					data-tag-name="link button"
					data-tag-icon
					data-tag-behaviour={behaviourTag}
					className="hover:bg-cta-actionhover hover:text-white w-full pr-0 whitespace-normal bg-white"
					variant="secondary"
					as="a"
					href={url}
					onClick={handleClick}
				>
					<span
						className={`ico ico-${iconClass} mr-2 inline-flex text-lg leading-none`}
					/>
					{text}
				</Button>
			) : (
				<Button
					target={behaviour === BehaviourTypes.NewTab ? '_blank' : undefined}
					rel={
						behaviour === BehaviourTypes.NewTab
							? 'noopener noreferrer'
							: undefined
					}
					data-tag-name="link button"
					data-tag-behaviour={behaviourTag}
					as="a"
					href={url}
					className="hover:bg-cta-actionhover hover:text-white justify-center w-full px-0 text-center whitespace-normal bg-white"
					variant="secondary"
					onClick={handleClick}
				>
					{text}
				</Button>
			)}
		</div>
	);
};

export default LinkButtonMessage;
